import { useCallback } from 'react';
import { useSearchParams } from 'react-router';
/**
 * Write one query parameter, leaving the rest of the query alone. The
 * counterpart to {@link useQueryParam}. A falsy value deletes the parameter, so
 * a default never shows up in the URL.
 *
 * Never scrolls: the page is the same, only its query moved, so the app's
 * ScrollRestoration leaves the scroll position where it was.
 *
 * The callback changes identity on every navigation, so an effect that depends
 * on it re-runs on each one.
 */
export const useWriteQueryParam = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    return useCallback((param, value, { replace = false } = {}) => {
        const next = new URLSearchParams(searchParams);
        if (value) {
            next.set(param, value);
        }
        else {
            next.delete(param);
        }
        setSearchParams(next, { replace, preventScrollReset: true });
    }, [searchParams, setSearchParams]);
};
